/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const PAGINATOR_SEARCH_MODEL = {
    from: null,
    to: null,
    page: 1,
    size: 10,
    query: null
}